// Framer Motion Animation Library
import { useInView } from "react-intersection-observer";
import { motion, useAnimationControls } from 'framer-motion';
import { useEffect } from 'react';

export function FadeInAnimation(props) {
    const controls = useAnimationControls();
    const introControls = useAnimationControls();
    const [ref, inView, entry] = useInView({ threshold: 0.25 });

    useEffect(() => {
        if (inView) {
            controls.start("visible");
            introControls.start("flyInLeftVisible");
        } else {
            controls.start("hidden");
            introControls.start("flyInLeftHidden");
        }
    }, [controls, introControls, inView]);

    const variants = {
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.5,
                delayChildren: 0.2,
                staggerChildren: 0.1,
            }
        },
        hidden: {
            y: entry,
            opacity: 0,
        },
    }

    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={variants}
        >
            {props.block}                   
        </motion.div>
    )
}